import { unformat } from 'accounting-js';

const isZeroOrGreaterCurrency = (rule, value, callback) => {
	(unformat(value) > 0) ? callback() : callback(new Error('This field must be 0 or greater'));
}

function validationMapper(field_array, rule_array){
	const return_object = {};
	field_array.forEach( field => {
		return_object[field] = rule_array;
	})
	return return_object;
}

export function mapSimpleValidation(field_array){
	const rule_array = [ { required: true, message: 'This field is required'}	];
	return validationMapper(field_array, rule_array);
}

export function mapSimpleArrayValidation(field_array){
	const rule_array = [ { type: 'array', required: true, message: 'This field is required'} ];
	return validationMapper(field_array, rule_array);
}

export function mapEmailValidation(field_array){
	const rule_array = [
		{ required: true, message: 'This field is required'},
		{ type: 'email', message: 'This field must be a valid email address', trigger: 'blur'}
	];
	return validationMapper(field_array, rule_array);
}

export function mapNonZeroCurrencyValidation(field_array){
	const rule_array = [
		{ required: true, message: 'This field is required'},
		{ validation: isZeroOrGreaterCurrency , trigger: 'blur'}
	];
	return validationMapper(field_array, rule_array);
}

export function mapPhoneValidation(field_array){
	const rule_array = [
		{ required: true, message: 'This field is required'},
		{ min: 14, max: 14, message: 'Please enter a ten-digit phone number', trigger: 'blur'}
	];
	return validationMapper(field_array, rule_array);
}
